import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ProgressService } from '../lib/progress.service';
import { ProgressInfoComponent } from '../progress-info/progress-info.component';

@Component({
  imports: [CommonModule, RouterOutlet, ProgressInfoComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent implements OnInit {
  public progressService = inject(ProgressService);
  constructor(
    private gtmService: GoogleTagManagerService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };

        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  protected readonly history = history;
}
